import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private closeExamModalSubject = new BehaviorSubject(null);
  private modalTypeSubject = new BehaviorSubject('');
  private modals: any[] = [];

  closeExamModal = this.closeExamModalSubject.asObservable();
  modalType = this.modalTypeSubject.asObservable();

  updateCloseExamInformation(closeExam: any): void {
    this.closeExamModalSubject.next(closeExam);
  }

  updateModalType(modalType: string): void {
    this.modalTypeSubject.next(modalType);
  }

  add(modal: any): void {
    this.modals.push(modal);
  }

  remove(id: string): void {
    this.modals = this.modals.filter((x) => x.id !== id);
  }

  open(): void {
    const modal = this.modals.find((x) => x.id === 'modal');
    modal.open();
  }

  close(): void {
    const modal = this.modals.find((x) => x.id === 'modal');
    modal.close();
  }
}
